module.exports = __webpack_public_path__ + "img/figma.1ea25bb6.png";